import React from 'react';
import { Col, Container } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import Forms from './components/Forms/index';

const ClienteCadastro = () => {
  return <Container fluid>
      <Col md={12}>
        <PageHeader title="" routeSegments={[{
        name: 'Início'
      }, {
        name: 'Clientes',
        path: '/pages/clientes'
      }, {
        name: 'Cadastro'
      }]} />
      </Col>
      <Forms />
    </Container>;
};

export default ClienteCadastro;
